import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h1 className="text-danger text-center">Error 404, This page is not found</h1>
        </div>
    );
};

export default NoMatch;